import React from 'react';
import { Navigate } from 'react-router-dom';
import CheckPermission from '../hooks/CheckPermission';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ moduleName = null, permission = null, allowCallCenter = false, children }) => {
  const { hasPermission } = CheckPermission();
  const user = useSelector(state => state?.auth?.user);
  const isAllowedCallCenter = allowCallCenter && user?.role?.name_en === 'Call Center';

  if (hasPermission(moduleName, permission) || isAllowedCallCenter) {
    return children;
  } else {
    toast.error('You do not have access to this module.');
  }

  return (
    <div>
      <Navigate to='/dashboard' replace />
    </div>
  );
};

export default ProtectedRoute;
